export const INVESTIGATION_STATUS_CONFIG = {
  INVESTIGATION_STATUS_UNSPECIFIED: { intent: 'none', label: 'Unknown' },
  INVESTIGATION_STATUS_ACTIVE: { intent: 'primary', label: 'Active' },
  INVESTIGATION_STATUS_COMPLETED: { intent: 'success', label: 'Completed' },
  INVESTIGATION_STATUS_FAILED: { intent: 'danger', label: 'Failed' }
};

export const getInvestigationStatusConfig = (status) =>
  INVESTIGATION_STATUS_CONFIG[status] || INVESTIGATION_STATUS_CONFIG.INVESTIGATION_STATUS_UNSPECIFIED;
